import { connect } from 'react-redux';
import Landing from '../../../components/landing/Landing';
import { profile, sucursal_id } from 'core/selectors';

export default connect(
  state => ({
    profile: profile(state),
    sucursal_id: sucursal_id(state),
  }),
  {},
)(Landing);
